export const ROUTES = {
    DEFAULT: '/',
    VEHICLE: 'vehicle',
    VEHICLE_BY_VIN: 'vehicle/:vin?',
    SIMULATIONS: 'simulations',
    SIMULATIONS_V2: 'simulations/v2',
    SETTINGS: 'settings',
    ERROR: 'error',
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];
